import { Col, Row } from "antd";
import {
  CommonStatus,
  DeviceType,
  SocketUpdateTableType,
} from "../../constants/enum";
import { ConversationEvent, queryKeys, router } from "../../constants/constans";
import { Navigate, useFetcher } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import {
  getListStaffDuplicate,
  getListTableSession,
  getListTimeWorkStaff,
  syncDataTableSession,
  updateTableSessionRealtime,
} from "../../api/tableSession";
import { useMutation, useQuery, useQueryClient } from "react-query";

import Cookies from "js-cookie";
import { Footer } from "../../Component/Footer";
import { SocketClient } from "../../utils/socket";
import { Taku } from "../../Component/Taku";
import { TakuContext } from "../../providers/TakuProvider";
import classNames from "classnames";
import { getDefaultConfigOfTable } from "api/table";
import { getListHost } from "api/host";
import moment from "moment";
import styles from "./style.module.scss";
import useBreakpoint from "../../hooks/useBreakPoint";
import { useContext } from "react";
import useIsMobile from "../../hooks/useIsMobile";
import useNetworkStatus from "hooks/useNetworkStatus";
import useProfile from "hooks/useProfile";
import useUpdateTable from "hooks/useUpdateTable";
import useZoom from "../../hooks/useZoomOptions";

export default function Home() {
  const queryClient = useQueryClient();
  const isOnline = useNetworkStatus();
  const { profile } = useProfile(true);
  const mustSync = useRef<boolean>(false);
  const syncDataTableSessionAction = useMutation(syncDataTableSession);
  const { isUpdate } = useUpdateTable();
  const firstRender = useRef<boolean>(true);
  const { isMobile } = useIsMobile();
  const deviceType = useBreakpoint();
  useZoom({ noZoomSelectors: [".no-zoom"] });
  const inSleepMode = useRef<boolean>(false);

  const [isTabVisible, setIsTabVisible] = React.useState(!document.hidden);

  const updateTableSessionRealtimeAction = useMutation(
    updateTableSessionRealtime
  );
  const { data: listTableSession, refetch } = useQuery(
    queryKeys.listTableSession,
    () => getListTableSession({}),
    {
      keepPreviousData: false,
      enabled: true,
      onSuccess: (data) => {},
    }
  );
  useQuery(queryKeys.listStaffDuplicate, () => getListStaffDuplicate({}), {
    keepPreviousData: false,
    enabled: !!Cookies.get("token"),
    onSuccess: (data) => {
      firstRender.current = false;
    },
  });

  const { data: defaultConfig } = useQuery(
    queryKeys.defaultConfigTable,
    getDefaultConfigOfTable,
    {
      onError: (err) => {},
      onSuccess: (data) => {
        const usernameRemember = Cookies.get("usernameRemember");
        if (!!usernameRemember) {
          localStorage.setItem(
            `defaultConfigTable-${usernameRemember}`,
            JSON.stringify(data)
          );
        }
      },
    }
  );

  useQuery(queryKeys.listTimeWorkStaff, getListTimeWorkStaff);

  useQuery(queryKeys.listHost, getListHost, {
    onError: (err) => {},
    onSuccess: (data) => {
      const usernameRemember = Cookies.get("usernameRemember");
      if (!!usernameRemember) {
        localStorage.setItem(
          `listHost-${usernameRemember}`,
          JSON.stringify(data)
        );
      }
    },
  });

  useEffect(() => {
    if (!!profile) {
      Cookies.set("profileRemember", JSON.stringify(profile));
    }
  }, [profile]);
  useEffect(() => {
    if (!isOnline) {
      mustSync.current = true;
    }
    if (!!isOnline && mustSync.current) {
      const listTableEndString = localStorage.getItem(`list-table-end`);
      let listTableEnd;
      if (!!listTableEndString) {
        listTableEnd = JSON.parse(listTableEndString);
      }
      syncDataTableSessionAction.mutate(
        {
          listTableSession: listTableSession?.data,
          listTableEnd,
        },
        {
          onSuccess: (data) => {
            localStorage.removeItem(`list-table-end`);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          },
        }
      );
    }
  }, [isOnline]);
  useEffect(() => {
    // Function to fetch data from the API

    const updateStaffDuplicate = async () => {
      if (!isOnline || !!firstRender.current) return;
      queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
    };

    // Call the fetchData function immediately
    updateStaffDuplicate();

    const intervalId = setInterval(updateStaffDuplicate, 60000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [moment().minutes(), isOnline, firstRender.current]);

  useEffect(() => {
    const { socket } = new SocketClient({});

    socket.on(ConversationEvent.RELOAD_TABLE, (data) => {
      if (data?.isReload) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else if (inSleepMode.current) {
        updateTableSessionRealtimeAction.mutate(
          {
            isReload: true,
          },
          {
            onSuccess: (data) => {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            },
          }
        );
      }
    });

    socket.on(ConversationEvent.UPDATE_DETAIL_TABLE, (data) => {
      const listTableSessionCurrent = queryClient.getQueryData(
        queryKeys.listTableSession
      ) as any;
      switch (data?.type) {
        case SocketUpdateTableType.EDIT:
          if (Array.isArray(listTableSessionCurrent?.data)) {
            const dataReplace = listTableSessionCurrent?.data?.findIndex(
              (item: any) => item?._id === data?.data?._id
            );
            listTableSessionCurrent?.data?.splice(dataReplace, 1, data?.data);
            queryClient.setQueryData(
              queryKeys.listTableSession,
              listTableSessionCurrent
            );
            queryClient.invalidateQueries(queryKeys.listTimeWorkStaff);
          }
          break;

        case SocketUpdateTableType.DELETE:
          if (Array.isArray(listTableSessionCurrent?.data)) {
            const dataReplace = listTableSessionCurrent?.data?.findIndex(
              (item: any) => item?._id === data?.tableId
            );
            listTableSessionCurrent?.data?.splice(dataReplace, 1);
            queryClient.setQueryData(
              queryKeys.listTableSession,
              listTableSessionCurrent
            );
            queryClient.invalidateQueries(queryKeys.sortListTable);
          }
          break;

        case SocketUpdateTableType.ADD:
          if (Array.isArray(listTableSessionCurrent?.data)) {
            listTableSessionCurrent?.data?.push(data?.data);
            queryClient.setQueryData(
              queryKeys.listTableSession,
              listTableSessionCurrent
            );
            queryClient.invalidateQueries(queryKeys.sortListTable);
            queryClient.invalidateQueries(queryKeys.listTimeWorkStaff);
          }
          break;

        default:
          break;
      }
    });

    socket.on(ConversationEvent.UPDATE_TABLE, () => {
      queryClient.invalidateQueries(queryKeys.listTableSession);
    });

    return () => {
      socket.off(ConversationEvent.RELOAD_TABLE);
      socket.off(ConversationEvent.UPDATE_DETAIL_TABLE);
    };
  }, [Cookies.get("token"), queryClient]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabVisible(!document.hidden);
      if (!document.hidden) {
        if (
          (defaultConfig as any)?.data?.autoNextStep === CommonStatus.ACTIVE
        ) {
          inSleepMode.current = true;

          setTimeout(() => {
            updateTableSessionRealtimeAction.mutate(
              {},
              {
                onSuccess: (data) => {
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 2000);
                },
              }
            );
          }, 2000);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [queryClient, defaultConfig, refetch]);

  const handleGetListDuplicate = () => {
    const listStaffWorking = [] as any[];
    const listStaffInfo = [] as any[];
    const infoWorkingOfStaff = {} as any;
    listTableSession?.data?.forEach((item: any) => {
      if (Array.isArray(item?.timeLineInfo) && item?.timeLineInfo.length > 0) {
        item.timeLineInfo?.forEach((timeLine: any) => {
          if (!listStaffWorking.includes(timeLine?.id)) {
            listStaffWorking.push(timeLine?.id);
            listStaffInfo.push(timeLine);
          }
          if (Object.keys(infoWorkingOfStaff).includes(timeLine?.id)) {
            infoWorkingOfStaff[`${timeLine.id}`].push({
              ...timeLine,
              tableId: item?._id,
              infoTable: item?.tableConfig,
              infoSession: item,
            });
          } else {
            infoWorkingOfStaff[`${timeLine.id}`] = [
              {
                ...timeLine,
                tableId: item?._id,
                infoTable: item?.tableConfig,
                infoSession: item,
              },
            ];
          }
        });
      }
    });

    const currentOffset = moment().utcOffset();
    const listTable = [] as any[];

    listStaffWorking.forEach((staff) => {
      const listDuplicateOfStaff = [] as any[];
      let listChecked = [] as any[];
      if (Array.isArray(infoWorkingOfStaff?.[`${staff}`])) {
        const staffInfo = listStaffInfo?.find((item) => item.id === staff);
        infoWorkingOfStaff?.[`${staff}`]?.forEach((time: any) => {
          listDuplicateOfStaff.push([{ ...time, staffInfo }]);
        });

        const numberOfWorkingStaff = infoWorkingOfStaff?.[`${staff}`]?.length;
        for (let i = 0; i < numberOfWorkingStaff; i++) {
          for (let t = i + 1; t < listDuplicateOfStaff?.length; t++) {
            const time1 = infoWorkingOfStaff?.[`${staff}`]?.[i];
            const listTime2 = (listDuplicateOfStaff?.[t] || []) as any[];
            let overlapCount = 0;
            listTime2?.forEach((time2) => {
              if (
                time1?.startTime &&
                time2?.startTime &&
                time1?.endTime &&
                time2?.endTime &&
                time1?.tableId !== time2?.tableId &&
                time1?.host?.id === time2?.host?.id
              ) {
                const combinedTime1 = moment(time1?.dateReal).set({
                  hour: parseInt(
                    (time1?.endTime || "").split(":")[0] ?? "0",
                    10
                  ),
                  minute: parseInt(
                    (time1?.endTime || "").split(":")?.[1] ?? "0",
                    10
                  ),
                  second: 0,
                  millisecond: 0,
                });
                const combinedTime2 = moment(time2?.dateReal).set({
                  hour: parseInt(
                    (time2?.endTime || "").split(":")[0] ?? "0",
                    10
                  ),
                  minute: parseInt(
                    (time2?.endTime || "").split(":")[1] ?? "0",
                    10
                  ),
                  second: 0,
                  millisecond: 0,
                });

                if (
                  moment(time1?.endTime, "HH:mm").isBefore(
                    moment(time1?.infoTable?.startTime, "HH:mm")
                  )
                ) {
                  combinedTime1.add(1, "day");
                }
                if (
                  moment(time2?.endTime, "HH:mm").isBefore(
                    moment(time2?.infoTable?.startTime, "HH:mm")
                  )
                ) {
                  combinedTime2.add(1, "day");
                }

                const isOverlap =
                  (moment(time2?.startTime, "HH:mm").isBetween(
                    moment(time1?.startTime, "HH:mm"),
                    combinedTime1,
                    null,
                    "()"
                  ) ||
                    moment(time2?.endTime, "HH:mm").isBetween(
                      moment(time1?.startTime, "HH:mm"),
                      combinedTime1,
                      null,
                      "()"
                    ) ||
                    moment(time1?.startTime, "HH:mm").isBetween(
                      moment(time2?.startTime, "HH:mm"),
                      combinedTime2,
                      null,
                      "()"
                    ) ||
                    moment(time1?.endTime, "HH:mm").isBetween(
                      moment(time2?.startTime, "HH:mm"),
                      combinedTime2,
                      null,
                      "()"
                    ) ||
                    (moment(time1?.startTime, "HH:mm").isSame(
                      moment(time2?.startTime, "HH:mm")
                    ) &&
                      combinedTime1.isSame(combinedTime2))) &&
                  combinedTime1.isAfter(
                    moment().subtract(
                      currentOffset - Number(time1?.infoTable?.utcOffset),
                      "m"
                    )
                  ) &&
                  combinedTime2.isAfter(
                    moment().subtract(
                      currentOffset - Number(time2?.infoTable?.utcOffset),
                      "m"
                    )
                  );

                if (!!isOverlap) {
                  overlapCount++;
                }
              }
            });

            if (overlapCount === listTime2.length) {
              listDuplicateOfStaff.push([...listTime2, time1]);
            }
          }
        }
        const listTime = listDuplicateOfStaff.filter((item) => item.length > 1);
        listTime.sort((a, b) => b.length - a.length);
        listTime.forEach((list) => {
          const joinStringChecker = list.map((item: any) => item?.tableId);

          if (
            !listChecked.some((value) =>
              joinStringChecker.every((element: any) => value.includes(element))
            )
          ) {
            listChecked.push(joinStringChecker);
            listTable.push({ staffInfo: list[0]?.staffInfo, table: list });
          }
        });
      }
    });
    queryClient.setQueryData(queryKeys.listStaffDuplicate, {
      data: listTable,
    });

    // get list-time-staff
    queryClient.setQueryData(queryKeys.listTimeWorkStaff, {
      data: infoWorkingOfStaff,
    });
  };
  useEffect(() => {
    if (!isOnline) {
      handleGetListDuplicate();
    }
  }, [listTableSession?.data?.length, isOnline, isUpdate]);

  useEffect(() => {
    if (!isOnline) {
      const usernameRemember = Cookies.get("usernameRemember");
      if (!!usernameRemember) {
        const listHostCache = localStorage.getItem(
          `listHost-${usernameRemember}`
        );
        const listHostCurrent = queryClient.getQueryData(queryKeys.listHost);
        if (!!listHostCache && !listHostCurrent) {
          try {
            queryClient.setQueryData(
              queryKeys.listHost,
              JSON.parse(listHostCache)
            );
          } catch (error) {
            localStorage.removeItem(`listHost-${usernameRemember}`);
          }
        }

        // default config
        const defaultConfigTableCache = localStorage.getItem(
          `defaultConfigTable-${usernameRemember}`
        );
        const defaultConfigTableCurrent = queryClient.getQueryData(
          queryKeys.defaultConfigTable
        );

        if (!!defaultConfigTableCache && !defaultConfigTableCurrent) {
          try {
            queryClient.setQueryData(
              queryKeys.defaultConfigTable,
              JSON.parse(defaultConfigTableCache)
            );
          } catch (error) {
            localStorage.removeItem(`defaultConfigTable-${usernameRemember}`);
          }
        }
      }
    }
  }, [isOnline]);

  const isAuthenticated = !!Cookies.get("token");
  if (!isAuthenticated) return <Navigate to={router.Auth.Login} />;

  const handleGetInfoTableSession = (index: number) => {
    const exitsInfo = listTableSession?.data?.find(
      (item: any) => item.index === index + 1
    );
    if (!exitsInfo) return null;
    return { ...exitsInfo, isSetup: true };
  };

  return (
    <div
      className={classNames(styles.homeContainer, {
        [styles.inDesktop]: [DeviceType.Desktop, DeviceType.Large].includes(
          deviceType
        ),
        [styles.isMobile]: !!isMobile,
      })}
    >
      <div className="wrapper bg "></div>
      {isMobile ? (
        <div className={styles.mobileContainer}>
          <Taku id={1} infoTable={handleGetInfoTableSession(0)} />
          <Taku id={2} infoTable={handleGetInfoTableSession(1)} />
          <Taku id={3} infoTable={handleGetInfoTableSession(2)} />
          <Taku id={4} infoTable={handleGetInfoTableSession(3)} />
          <Taku id={5} infoTable={handleGetInfoTableSession(4)} />
          <Taku id={6} infoTable={handleGetInfoTableSession(5)} />
          <Taku id={7} infoTable={handleGetInfoTableSession(6)} />
          <Taku id={8} infoTable={handleGetInfoTableSession(7)} />
          <Taku id={9} infoTable={handleGetInfoTableSession(8)} />
          <Taku id={10} infoTable={handleGetInfoTableSession(9)} />
          <Taku id={11} infoTable={handleGetInfoTableSession(10)} />
          <Taku id={12} infoTable={handleGetInfoTableSession(11)} />
          <Taku id={13} infoTable={handleGetInfoTableSession(12)} />
          <Taku id={14} infoTable={handleGetInfoTableSession(13)} />
          <Taku id={15} infoTable={handleGetInfoTableSession(14)} />
        </div>
      ) : (
        <div className="zoom-container">
          <div className="line mt30 ">
            <Taku id={1} infoTable={handleGetInfoTableSession(0)} />
            <Taku id={2} infoTable={handleGetInfoTableSession(1)} />
            <Taku id={3} infoTable={handleGetInfoTableSession(2)} />
            <Taku id={4} infoTable={handleGetInfoTableSession(3)} />
            <Taku id={5} infoTable={handleGetInfoTableSession(4)} />
          </div>
          <div className="line ">
            <Taku id={6} infoTable={handleGetInfoTableSession(5)} />
            <Taku id={7} infoTable={handleGetInfoTableSession(6)} />
            <Taku id={8} infoTable={handleGetInfoTableSession(7)} />
            <Taku id={9} infoTable={handleGetInfoTableSession(8)} />
            <Taku id={10} infoTable={handleGetInfoTableSession(9)} />
          </div>
          <div className="line lastLine">
            <Taku id={11} infoTable={handleGetInfoTableSession(10)} />
            <Taku id={12} infoTable={handleGetInfoTableSession(11)} />
            <Taku id={13} infoTable={handleGetInfoTableSession(12)} />
            <Taku id={14} infoTable={handleGetInfoTableSession(13)} />
            <Taku id={15} infoTable={handleGetInfoTableSession(14)} />
          </div>
          <div style={{ height: "1px" }}></div>
        </div>
      )}

      <Footer listTableSession={listTableSession} />
    </div>
  );
}
